import supabase from "../../../shared/database/supabase";
import { CustomError } from "../../../shared/error/error";

export interface CreateInvoiceRequest {
  costumer_id: string;
  total_pericias: number;
  total_price: number;
  start_date: string;
  end_date: string;
  agent_comission: number;
  pericias: PericiaInvoice[];
  lines?: string[];
}

interface PericiaInvoice {
  id: string;
  car_id: string;
}

export interface CreateInvoiceResponse {
  id: string;
}

export const createInvoiceReq = async (req: CreateInvoiceRequest): Promise<CreateInvoiceResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke("create-invoice", {
      body: JSON.stringify({ ...req })
    });

    if (error) throw error;
    if (data.error) throw data.error;

    return data;
  } catch (err) {
    const apiError = err as CustomError;
    console.error(`API Error: ${apiError.message}`);

    if (apiError && apiError.code && apiError.message && apiError.toast_message && apiError.http_status_code) {
      throw new CustomError(apiError);
    }

    throw new CustomError({});
  }
};
